import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/cm/guideline-texts', { params });
  },
  detail(id) {
    return axios.get(`/v1/cm/guideline-texts/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/cm/guideline-texts/${id}`, params);
  },
  create(data) {
    return axios.post('/v1/cm/guideline-texts', data);
  },
  delete(id) {
    return axios.delete(`/v1/cm/guideline-texts/${id}`);
  },
  upload(data) {
    return axios.post('/v1/cm/upload-images', data);
  },
  getMenu(params = {}) {
    return axios.get('/v1/menu', { params });
  },
  getHierarchy(params = {}) {
    return axios.get('/v1/hierarchy-menu', { params });
  }
};
